import Form from '../../views/Email/Form';
import { __ADMINISTRADOR, __CENTRAL } from '../../security/RoleConfiguration';

export const path = '/admin/emails';

export const listRoutes = [
    {
        path: path + '/:id',
        component: Form,
        roles: [ __ADMINISTRADOR, __CENTRAL ],
    }
];

export default listRoutes;